"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @donotoptimize bottom left corner of black triangle has weird artifacts
 */
export const EcoFriendly = createSVGIcon(
  <>
    <path d="M10.625 4L18.9605 18.4375H2.28951L10.625 4Z" fill="#BDBFAE" />
    <path
      d="M8.96357 15.3125L14.5625 5.04443L20.1614 15.3125L8.96357 15.3125Z"
      stroke="#312921"
    />
  </>,
  "Eco-friendly",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Eco-friendly",
    fill: "none",
    className: legacyIconCls(),
  }
);
